const highestMinOrVal = (row) => {
    const highest = parseFloat(row.current_count) > parseFloat(row.min)
        ? row.current_count
        : row.min;
    return parseFloat(highest)
};

const getRowHighestCount = (rows) => {
    let count = 0;
    rows.forEach(x => {
        count += highestMinOrVal(x);
    });
    return count;
}

const getMinTotalCountForOtherRows = (rows, currentRow) => {
    let count = 0;
    rows.forEach(x => {
        if(x.id !== currentRow.id){
            count += x.min;
        }
    });
    return count;
}

const getMinTotalCountForAllRows = (rows) => {
    let count = 0;
    rows.forEach(x => {
        count += x.min;
    });
    return count;
}

export const getMinValAllowedForTotalSampleSize = (quota) => {
    const groupCounts = [];
    quota.groups.forEach(group => {
        let count = 0;
        group.rows.forEach(row => {
            count += row.min;
        });
        groupCounts.push(count);
    });
    return groupCounts.length
        ? groupCounts.sort((a,b)=>a-b)[groupCounts.length - 1]
        : 0;
}

export const addSpareSlotsToQuotaGroups = (state) => {
    const quota = JSON.parse(JSON.stringify(state.task.quota));
    quota.groups.forEach(group => {
        group.maxValAllowedForNewRows = quota.total_sample_size - getMinTotalCountForAllRows(group.rows);
        group.rows.forEach(row => {
            let groupHighestOfMinAndCurrentCountTotal = getRowHighestCount(group.rows);
            row.spareSlotsAvailable = (quota.total_sample_size - groupHighestOfMinAndCurrentCountTotal) + highestMinOrVal(row) - row.current_count;

            const minTotalCountForOtherRows = getMinTotalCountForOtherRows(group.rows, row);
            row.maxValueAllowedForMin = quota.total_sample_size - minTotalCountForOtherRows;
        });
    });
    return quota.groups;
}